/* Widget registry + per-role visibility (mock backend via localStorage).
   In your real app, swap load/save for your API + redux. */

export const WIDGETS = [
  {
    id: 'attention',
    label: 'Needs your attention',
    description: 'Priority queue of cases requiring action',
  },
  {
    id: 'kpis',
    label: 'KPI cards',
    description: 'Cases in flight, certificates, verifications, reliance',
  },
  {
    id: 'throughput',
    label: 'Throughput trend',
    description: 'Certificates vs verifications, 12-week interactive chart',
  },
  {
    id: 'funnel',
    label: 'Onboarding funnel',
    description: 'Stage distribution with bottleneck marker',
  },
  {
    id: 'riskMix',
    label: 'Risk mix',
    description: 'Active customer risk distribution',
  },
  {
    id: 'alertBanner',
    label: 'Active risk banner',
    description: 'Portfolio-level risk callout',
  },
  {
    id: 'activity',
    label: 'Activity feed',
    description: 'Recent audit-trail events',
  },
  {
    id: 'usageBar',
    label: 'Plan usage',
    description: 'Metered spend, credits & certification volume',
  },
];

export const ROLES = [
  { id: 'agency', label: 'Agency (Admin)' },
  { id: 'agency_compliance', label: 'Compliance Officer' },
  { id: 'staff_member', label: 'Staff Member' },
  { id: 'auditor', label: 'Auditor' },
];

const KEY = 'widget_visibility_v1';
const ALL = WIDGETS.map((w) => w.id);

export const DEFAULT_VISIBILITY = {
  agency: ALL,
  agency_compliance: ALL.filter((id) => id !== 'usageBar'),
  staff_member: [
    'attention',
    'kpis',
    'throughput',
    'funnel',
    'activity',
    'usageBar',
  ],
  auditor: ['attention', 'kpis', 'activity'],
};

export function loadVisibility() {
  try {
    const raw = localStorage.getItem(KEY);
    if (raw) return { ...DEFAULT_VISIBILITY, ...JSON.parse(raw) };
  } catch {
    /* ignore corrupt storage */
  }
  return { ...DEFAULT_VISIBILITY };
}

export function saveVisibility(map) {
  try {
    localStorage.setItem(KEY, JSON.stringify(map));
  } catch {
    /* storage unavailable */
  }
}
